import React, { useEffect, useState } from "react";
import { getPayment, getPaymentByDate } from "features/Payment/paymentSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatNumber } from "utils/common";
import { SERVICE } from "constants/global";
import { Notice } from "components";
import Card from "features/Payment/components/Card";
import ErrorDB from "components/ErrorDB";

function Payment() {
  const dispatch = useDispatch();

  const [isSelected, setIsSelected] = useState(false);
  const [paymentInfoName, setPaymentInfoName] = useState();

  const { payment, payment_info, noticesInit, isInLine, isInLinePayment, isInLineNotice } = useSelector(
    (state) => state.payment
  );

  useEffect(() => {
    dispatch(getPayment({ service: SERVICE }));
  }, []);

  const getPaymentByPaymentInfo = (item) => {
    setPaymentInfoName(item.payment_name);
    dispatch(
      getPaymentByDate({
        service: SERVICE,
        payment_info_id: item.id,
      })
    );
  };

  const getInfoBank = (payment) => {
    if (payment.bankType == 1)
      return (
        payment?.yuchoCode &&
        payment?.yuchoAccountNumber &&
        payment?.yuchoAccountName &&
        `${payment?.yuchoCode} / ${payment?.yuchoAccountNumber} / ${payment?.yuchoAccountName}`
      );
    else if (payment.bankType == 2) {
      return (
        payment?.bankName &&
        payment?.branchName &&
        payment?.branchCode &&
        payment?.accountNumber &&
        `${payment?.bankName} / ${payment?.branchName} / ${payment?.branchCode} / ${payment?.accountNumber}`
      );
    } else {
      return null;
    }
  };

  if (!payment_info && !isInLine && !isInLineNotice && !isInLinePayment) return null;

  return (
    <div className="w-80 py-0 py-md-3">
      <Notice noticesInit={noticesInit} isInLine={isInLine || isInLineNotice}/>
      {
        <div>
          <div className="text-center fs-20 fs-sm-18 fw-600 my-3 my-md-4">
            支払履歴
          </div>
          {isInLine || isInLinePayment ? <ErrorDB style={'mt-4'}/> :
          payment_info?.length > 0 ? (
            <>
              <div className="px-3 px-md-0">
                <div className="d-flex flex-column flex-md-row align-items-center mb-md-4">
                  <div className="border-point border-0 text-center order-2 order-md-1">
                    <div
                      className={`select-cutsom ${isSelected ? "show" : ""}`}
                      onClick={() => setIsSelected(!isSelected)}
                      onMouseLeave={() => setIsSelected(false)}
                    >
                      <div className="display">
                        {paymentInfoName
                          ? paymentInfoName
                          : payment_info[0].payment_name}
                      </div>
                      <svg
                        width="10"
                        height="5"
                        viewBox="0 0 10 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.01595 -3.35878e-07L4.73795 3.242L7.66995 -8.87341e-08L9.69995 0L5.24195 4.916L4.06595 4.916L-4.86374e-05 -4.24e-07L2.01595 -3.35878e-07Z"
                          fill="#333333"
                        />
                      </svg>

                      <ul className="options">
                        {payment_info.map((item) => (
                          <li
                            key={item.id}
                            className="option-item fs-16"
                            onClick={() => getPaymentByPaymentInfo(item)}
                          >
                            {item.payment_name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="px-md-4 text-center text-md-start text-select-next fs-13 fs-sm-11 order-1 order-md-2 mb-2 mb-md-0">
                    直近1年以内のポイント支払履歴を、月別でご覧いただけます。
                  </div>
                </div>

                <div className="bg-f8 bg-sm-white d-flex flex-column flex-md-row">
                  <div className="border-point border-sm-0 bg-white d-flex flex-wrap align-items-center justify-content-between px-3 px-md-1 px-lg-3 my-1 my-md-0">
                    <div className="fw-600 fs-16 fs-sm-12 text-grey">支払金額</div>
                    <div className="fw-600 fs-45 fs-sm-38 text-brown ms-0 ms-md-2 point-ellipsis">
                      {formatNumber(payment?.paid_amount)}
                      <span className="ms-2 fs-13 mt-2 mt-md-0">円</span>
                    </div>
                  </div>

                  <div className="bg-f8 fs-14 fs-sm-11 ps-0 ps-md-4 sp-sm-05 fw-400 text-md-start py-3">
                    <table className="bank">
                      <tbody>
                        <tr>
                          <td className="fs-12 fw-600 sp-6">ステータス</td>
                          <td>{payment?.status_name}</td>
                        </tr>
                        <tr>
                          <td className="fs-12 fw-600 sp-6">振込予定日</td>
                          <td>{payment?.payment_due_date}</td>
                        </tr>
                        <tr>
                          <td className="fs-12 fw-600 sp-6">振込日</td>
                          <td>{payment?.paymentDate}</td>
                        </tr>
                        <tr>
                          <td className="fs-12 fw-600">謝礼合計</td>
                          <td>
                            {formatNumber(
                              Number(payment?.paid_amount) +
                                Number(payment?.charge_amount)
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <td className="fs-12 fw-600 sp-6">手数料</td>
                          <td>△{formatNumber(payment?.charge_amount)}円</td>
                        </tr>
                        <tr>
                          <td className="fs-12 fw-600 align-top">振込口座</td>
                          <td>{getInfoBank(payment)}</td>
                        </tr>
                        
                        <tr>
                          <td className="fs-12 fw-600">備考</td>
                          <td>{payment?.note}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="content-layout my-3 py-3 px-3 px-lg-0">
                <div className="my-md-2 fs-14 fw-600">支払金額の内訳</div>
                <div className="border-color-black border-color-sm-none border-radius-bottom">
                  <div className="thead row py-1 gx-0 px-3 text-center d-none d-md-flex text-white bg-table-layout">
                    <div className="w-col-10">
                      <div className="row gx-0">
                        <div className="col-9">案件名</div>
                        <div className="col-3">ポイント確定日</div>
                      </div>
                    </div>
                    <div className="w-col-2">ポイント</div>
                  </div>
                  <div className="py-md-3 px-0 px-md-3">
                    {payment.payment_result?.map((item, index) => (
                      <Card key={index} payment_result={item} />
                    ))}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="border-color-red-light border-radius-sm-5 p-2 mx-3 mx-md-0 text-center fw-bolder text-red-light">
                支払履歴はありません
              </div>
            </>
          )}
        </div>
      }
    </div>
  );
}

export default Payment;
